var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumb-bar',{attrs:{"title":_vm.appTitle,"breadcrumbs":_vm.breadcrumbs}}),_c('v-container',[_c('productLinks',{attrs:{"add-enabled":_vm.enableAdd,"title":this.$t('titleProductLinks')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }